import { Component } from '@angular/core';

@Component({
  selector: 'app-remove-pdf-password-online',
  imports: [],
  templateUrl: './remove-pdf-password-online.component.html',
  styleUrl: './remove-pdf-password-online.component.css'
})
export class RemovePdfPasswordOnlineComponent {

}
